import { useSearch } from "context/SearchContext";
import { useState } from "react";

interface HotelInfoHeaderProps {
  handleStepChange?: (step: number) => void;
}

const Header = ({ handleStepChange }: HotelInfoHeaderProps) => {
  const [language, setLanguage] = useState("Français");
  const { setTempCurrency, tempCurrency } = useSearch();

  const languages = ["Français"];
  const currencies = ["EUR", "USD", "TND"];

  return (
    <div className="flex flex-col md:flex-row items-center justify-between bg-white p-4 border-b border-gray-200">
      {/* Hotel Name and Stars */}
      <div className="flex items-center mb-4 md:mb-0">
        <img
          src="https://www.hotelcarltontunis.com/backend/logo/1699540744.png"
          className="w-auto h-12 md:h-16 mr-2"
          alt="Logo de l'hôtel Carlton"
          title="Logo de l'hôtel Carlton"
        />
        <div className="flex flex-col md:flex-row md:items-center">
          <h1 className="text-lg md:text-xl font-normal text-black mr-0 md:mr-2">
            Hotel Carlton
          </h1>
          <div className="flex justify-center md:justify-start">
            {[...Array(3)].map((_, i) => (
              <svg
                key={i}
                className="w-4 h-4 md:w-5 md:h-5 text-yellow-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            ))}
          </div>
        </div>
      </div>

      {/* Language and Currency Selectors */}
      <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4 w-full sm:w-auto">
        {/* Language Select */}
        <select
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          className="w-full sm:w-36 border border-gray-200 rounded-none px-3 py-1 text-black focus:outline-none"
        >
          {languages.map((lang) => (
            <option key={lang} value={lang}>
              {lang}
            </option>
          ))}
        </select>

        {/* Currency Select */}
        {handleStepChange && (
          <select
            value={tempCurrency}
            onChange={(e) => {
              setTempCurrency(e.target.value);
              handleStepChange(0);
            }}
            className="w-full sm:w-36 border border-gray-200 rounded-none px-3 py-1 text-black focus:outline-none"
          >
            {currencies.map((curr) => (
              <option key={curr} value={curr}>
                {curr}
              </option>
            ))}
          </select>
        )}
      </div>
    </div>
  );
};

export default Header;
